import { withProps, compose } from 'recompose'
import withShowConfirmTireSizeModalPreconfigured from 'components/common/hoc/withShowConfirmTireSizeModalPreconfigured'
import withNavigateToTireSearchOrShowYmme from 'components/common/hoc/withNavigateToTireSearchOrShowYmme'

const withConfigureHandleShopTires = withProps(({ navigateToTireSearchOrShowYmme, onClick }) => ({
  handleShopTires: onClick || navigateToTireSearchOrShowYmme
}))

export default compose(
  withNavigateToTireSearchOrShowYmme,
  withShowConfirmTireSizeModalPreconfigured,
  withConfigureHandleShopTires
)
